/* Whether a given username was generated by the backend instead of provided by the user. */
export const isUsernameGenerated = (username) => username && username.startsWith('user_');



// WEBPACK FOOTER //
// ./account/utils.js